
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IFormMetadata, IInfoTable, MetadataAction } from "@tylertech/tyler-api-types";

/**
 * PayableImportMetadataService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PayableImportMetadataService {
    constructor(private readonly $apiService: ApiService) { }
    
    CreateImportMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/CreateImportMetadata");
    }
    GetBudgetRecapMetadataAction(): Promise<MetadataAction> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetBudgetRecapMetadataAction");
    }
    GetImportCardMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportCardMetadata");
    }
    GetImportPayableCreatePaymentMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableCreatePaymentMetadata");
    }
    GetImportPayableGridLineMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableGridLineMetadata");
    }
    GetImportPayableItemFormMetadata(): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableItemFormMetadata");
    }
    GetImportPayableItemMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableItemMetadata");
    }
    GetImportPayableLineTable(): Promise<IInfoTable> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableLineTable");
    }
    GetImportPayableMassUpdateMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableMassUpdateMetadata");
    }
    GetImportPayableMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetImportPayableMetadata");
    }
    GetManualPaymentMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPayableImportMetadataService/GetManualPaymentMetadata");
    }
}
